module.exports = __webpack_public_path__ + "img/kaist_gallery11.14e757fa.jpg";